import { vaultParamsTransformer, VaultParamsType } from './vaultParamsTransformer';
import { userInfoTransformer, UserInfoType } from './userInfoTransformer';


interface VaultParamsWithUserDetailsType {
  userDetailsDTO: UserInfoType,
  vaultExtraParamsMap: VaultParamsType,
  scWalletFlag: number,
}
/**
 * @description
 * transformer for vault params api
 * @param data - response from vault api
 */
export const vaultParamsWithUserDetailsTransformer = (data:VaultParamsWithUserDetailsType) => {
  if (!data) {
    return {};
  }
  const { userDetailsDTO, vaultExtraParamsMap, scWalletFlag } = data;
  return {
    userDetailsDTO: userInfoTransformer(userDetailsDTO),
    vaultExtraParamsMap: vaultParamsTransformer(vaultExtraParamsMap),
    scWalletFlag,
  };
};
